export default __webpack_public_path__ + "static/media/icon.e5f3f3b4.png";